import { TypeIdSchema } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';

export const ReplayEventResponseSchema = Type.Object({
  object: Type.Literal('EventReplay'),
  event_id: TypeIdSchema('event'),
  endpoint_ids: Type.Array(TypeIdSchema('webhookEndpoint')),
});

export type ReplayEventResponse = Static<typeof ReplayEventResponseSchema>;
